export class Filter {
  constructor(fieldName, filterType, filterValue) {
    this.field = fieldName
    this.type = filterType
    this.value = filterValue
  }
}

export class FilterField {
  constructor(fieldName, label) {
    this.fieldName = fieldName
    this.label = label
  }
}

class Option {
  constructor(id, label, value) {
    this.id = id
    this.label = label
    this.value = value
  }
}

export const IS_OPTION = new Option("is", "Is", "is")
export const CONTAINS_OPTION = new Option("contains", "Contains", "contains")
export const IS_NOT_OPTION = new Option("is_not", "Is not", "is_not")
export const DOES_NOT_CONTAIN_OPTION = new Option(
  "not_contains",
  "Does not contain",
  "not_contains"
)
export const IS_ONE_OF_OPTION = new Option(
  "is_one_of",
  "Is one of",
  "is_one_of"
)
export const IS_NONE_OF_OPTION = new Option(
  "is_none_of",
  "Is none of",
  "is_none_of"
)
export const EQUALS_OPTION = new Option("is", "Equals", "is")
export const GREATER_THAN_OPTION = new Option("gt", "Greater than", "gt")
export const LESS_THAN_OPTION = new Option("lt", "Less than", "lt")
export const EXISTS_OPTION = new Option("exists", "Exists", "exists")
export const NOT_EXISTS_OPTION = new Option(
  "not_exists",
  "Does Not Exist",
  "not_exists"
)
export const IS_AFTER_OPTION = new Option("gt", "Is after", "gt")
export const IS_BEFORE_OPTION = new Option("lt", "Is before", "lt")
export const IS_TODAY_OPTION = new Option("is_today", "Is today", "is_today")
export const IS_BEFORE_TODAY_OPTION = new Option(
  "is_before_today",
  "Is before today",
  "is_before_today"
)
export const IN_LAST_3_DAYS_OPTION = new Option(
  "in_last_3_days",
  "Is in the last 3 days",
  "in_last_3_days"
)
export const IN_LAST_7_DAYS_OPTION = new Option(
  "in_last_7_days",
  "Is in the last 7 days",
  "in_last_7_days"
)
export const MORE_THAN_7_DAYS_AGO_OPTION = new Option(
  "more_than_7_days_ago",
  "Is more than 7 days ago",
  "more_than_7_days_ago"
)
export const MORE_THAN_A_MONTH_AGO_OPTION = new Option(
  "more_than_a_month_ago",
  "Is more than a month ago",
  "more_than_a_month_ago"
)
export const IN_LAST_3_MONTHS_OPTION = new Option(
  "in_last_3_months",
  "Is in the last 3 months",
  "in_last_3_months"
)
export const HAS_BEEN_CALLED_OPTION = new Option(
  "exists",
  "Has been called",
  "exists"
)
export const NEVER_CALLED_OPTION = new Option(
  "not_exists",
  "Has never been called",
  "not_exists"
)

export const TYPE_OPTIONS = [
  IS_OPTION,
  CONTAINS_OPTION,
  IS_NOT_OPTION,
  DOES_NOT_CONTAIN_OPTION,
  IS_ONE_OF_OPTION,
  IS_NONE_OF_OPTION,
  GREATER_THAN_OPTION,
  LESS_THAN_OPTION,
  EXISTS_OPTION,
  NOT_EXISTS_OPTION,
  IS_TODAY_OPTION,
  IS_BEFORE_TODAY_OPTION,
  IN_LAST_3_DAYS_OPTION,
  IN_LAST_7_DAYS_OPTION,
  MORE_THAN_7_DAYS_AGO_OPTION,
  MORE_THAN_A_MONTH_AGO_OPTION,
  IN_LAST_3_MONTHS_OPTION,
]

export const TYPE_OPTION_NAME_MAP = Object.fromEntries(
  TYPE_OPTIONS.map((option) => [option.id, option.label])
)

export const COUNTRIES = ["US", "CA"]

export const REALITY_FIELD_NAMES = {
  NAME: "name",
  MLS: "mls",
  MLS_ID: "mls_id",
  NO_OF_SALES: "total_transactions_count",
  SALES_VOLUME: "total_production",
  ALL_TIME_NO_OF_SALES: "all_time_transactions_count",
  ALL_TIME_SALES_VOLUME: "all_time_production",
  CITY: "city",
  EMAIL: "email",
  PHONE: "phone",
  VERIFIED_PHONE: "verified_phone",
  OFFICE_NAME: "office_name",
  BRAND: "brand__code",
  STATE: "state",
  COUNTY: "county",
  ZIPCODE: "zipcode",
  YEARS_IN_BUSINESS: "years_in_business",
  LIKELIHOOD_TO_MOVE: "likelihood_to_move",
  /** CRM My MLS Potential (tier + is / is not); handled server-side. */
  POTENTIAL_TIER: "potential_tier",
  ANNUAL_VALUE: "annual_value",
  ROLE: "role",
  /** CRM Import Leads batch name from the upload dialog. */
  UPLOAD_NAME: "upload_name",
  IS_DNC: "is_dnc",
  /** Yes / No: the lead has a number the Power Dialer can call. */
  HAS_CALLABLE_PHONE: "has_callable_phone",
  /** A saved Bulk search list; created by the Bulk search dialog, not typed in. */
  BULK_LIST: "bulk_list",
  CONCIERGE_DIAL_COUNT: "concierge_dial_count",
  CONCIERGE_LAST_DIALED_AT: "concierge_last_dialed_at",
  CONCIERGE_LAST_DISPOSITION: "concierge_last_disposition",
  CALL_PERFORMED_BY: "call_performed_by",
  CUSTOM_TAG: "custom_tag",
}
